import React from 'react';
import {
  Box,
  DisplayLineItem,
  Divider,
  FlexBox,
  Spacer,
  TextBody
} from '@directsoftware/ui-kit-web-admin';
import { useSelector } from 'react-redux';
import ReactI18n from 'react-i18n';
import moment from 'moment/moment';
import { selectVerificationState } from '../../../redux/slices/verification';
import { formatCurrency } from '../../../../shared/helpers';
import chargeDescription from '../../../utils/charge-description';
import {
  chargeRefundStatusLabel,
  refundTotal,
  settledGuestCharges
} from '../../../utils/guest-charges';
import RemainingTotal from '../../shared/remaining-total';

const VerificationPricingInfo = () => {
  const verificationState = useSelector(selectVerificationState);
  const brand = useSelector(state => state.brand);
  const translate = ReactI18n.getIntlMessage;

  const charges = settledGuestCharges(verificationState.charges);
  const refunded = refundTotal({
    charges,
    refunds: verificationState.refunds,
    pricePaid: verificationState.booking.price_paid
  });
  const currency = (charges[0] && charges[0].currency) || brand.currency;

  const renderCharge = charge => {
    const amount_charged = parseFloat(charge.amount_charged).toFixed(2);
    const description = [
      chargeDescription(charge, translate),
      chargeRefundStatusLabel(charge, translate)
    ]
      .filter(Boolean)
      .join(' · ');

    return (
      <DisplayLineItem
        key={`charge-${charge.id}`}
        label={`Payment: ${moment(charge.created_at).format(
          brand.date_format === 'DD/MM/YYYY' ? 'DD MMM, YYYY' : 'MMM DD, YYYY'
        )}`}
        description={description}
        value={`- ${formatCurrency(amount_charged, charge.currency)}`}
        removeBottomBorder
      />
    );
  };

  return (
    <>
      <Box paddingHorizontal="s" paddingTop="s">
        <FlexBox>
          <Box>
            <TextBody weight="semibold" textColor="dark-gray">
              {translate(`cx.global.total`)}
            </TextBody>
          </Box>
          <FlexBox flex="1" justifyContent="flex-end">
            <TextBody weight="semibold" textColor="dark-gray">
              {formatCurrency(
                verificationState.booking.price_total,
                brand.currency
              )}
            </TextBody>
          </FlexBox>
        </FlexBox>
        {charges.length > 0 ? (
          <>
            {charges.map(charge => renderCharge(charge))}
            {refunded > 0 && (
              <DisplayLineItem
                key="refunded"
                label={translate(`cx.receipt.refunded`)}
                value={`+ ${formatCurrency(refunded.toFixed(2), currency)}`}
                removeBottomBorder
              />
            )}
          </>
        ) : (
          <Spacer />
        )}
      </Box>
      <Divider />
      <Box padding="s">
        <RemainingTotal
          priceTotal={verificationState.booking.price_total}
          pricePaid={verificationState.booking.price_paid}
          balanceDueDate={verificationState.payment_balance_due_date}
          balanceDueOn={verificationState.payment_balance_due_on}
        />
      </Box>
    </>
  );
};

export default VerificationPricingInfo;
